import { useAccount as useNizzaAccount } from '@nizza/core';
import { useMutation } from '@tanstack/react-query';
import {
  createSubscription,
  updateSectionsGlobal,
  updateSubscription,
  updateSubscriptionStatus,
  updateSubscriptionType,
} from 'api';

export const useAccountHandlers = () => {
  const { refetchAccount: refetchInfoAccount } = useNizzaAccount();

  const changeSubscriptionTypeMutation = useMutation(updateSubscriptionType, {
    onSuccess: () => refetchInfoAccount(),
  });

  const changeSectionMutation = useMutation(updateSectionsGlobal, {
    onSuccess: () => refetchInfoAccount(),
  });

  const changeSubscriptionStatusMutation = useMutation(
    updateSubscriptionStatus,
    {
      onSuccess: () => refetchInfoAccount(),
    },
  );

  const createSubscriptionMutation = useMutation(createSubscription);

  const updateSubscriptionMutation = useMutation(updateSubscription);

  return {
    changeSubscriptionTypeMutation,
    changeSectionMutation,
    changeSubscriptionStatusMutation,
    createSubscriptionMutation,
    updateSubscriptionMutation,
  };
};
